import { render, staticRenderFns } from "./EditFolderAttributeForm.vue?vue&type=template&id=cafb703a"
import script from "./EditFolderAttributeForm.vue?vue&type=script&lang=js"
export * from "./EditFolderAttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports